module.exports = __webpack_public_path__ + "static/img/11.05e9cec0.png";